import React from "react";
import { styled } from "@linaria/react";
import { colors } from "../Theme";
import RestartLine from "../IconV2/react/RestartLine";

const Button = styled.button`
  all: unset;
  align-items: center;
  justify-self: start;
  color: ${colors.lightNitrogen500_Main};
  cursor: pointer;
  display: flex;
  font-size: 10px;
  line-height: 1em;
  gap: 4px;
`;

interface P extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  className?: string;
}

function RevertButton({ text, className, onClick }: P) {
  return (
    <Button className={className} tabIndex={-1} onClick={onClick} type="button">
      <RestartLine size="xs" />
      {text}
    </Button>
  );
}

export default React.memo(RevertButton);
